import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import Download from '../../images/icons/download.svg'
import Print from '../../images/icons/print.svg'
import Send from '../../images/icons/contact-black.svg'

export const StyledOverlayWrapper = styled.div`
  position: absolute;
  display: inline-block;
  width: initial !important;
  z-index: 99;
  ${({ $visibility }) => !$visibility && `display: none;`}
  ${({ $offsetX }) => $offsetX && `left:${pxToRem($offsetX)} ;`}
  ${({ $offsetY }) => $offsetY && `top:${pxToRem($offsetY)}; `}
`

export const StyledOverlay = styled.div`
  position: absolute;
  flex-direction: column;
  left: -${pxToRem(120)};
  display: flex;
  top: ${pxToRem(30)};
  box-shadow: ${({ theme }) =>
    `0 ${pxToRem(2)} ${pxToRem(10)} ${theme.colors.opacity.black20}`};
  ${({ theme }) => theme.colors.opacity.black40};
  ${({ theme }) => theme.colors.opacity.black40};
  transition: opacity 0.4s ease, transform 0.4s ease, visibility 0.4s;
  border-radius: ${pxToRem(6)};
  height: ${pxToRem(89)};
  padding: ${pxToRem(10)} ${pxToRem(20)};
  background: ${({ theme }) => theme.colors.unique.white};
`

export const OptionsDropDown = styled.div`
  flex-direction: row;
  display: flex;
  margin-top: ${pxToRem(2)};
  height: ${pxToRem(20)};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fonts.sizes.button};
  line-height: 0;
  font-weight: ${({ theme }) => theme.fonts.weight.semibold};
  align-items: center;
`

export const Separator = styled.div`
  margin: ${pxToRem(10)} 0;
  width: ${pxToRem(105)};
  height: ${pxToRem(1)};
  background-color: ${({ theme }) => theme.colors.primary.grey};
`

export const StyleIconDownload = styled(Download)`
  margin-right: ${pxToRem(10)};
  width: ${pxToRem(24)};
  cursor: pointer;
`

export const StyleIconPrint = styled(Print)`
  margin-right: ${pxToRem(10)};
  width: ${pxToRem(24)};
  cursor: pointer;
`

export const StyleIconSend = styled(Send)`
  margin-right: ${pxToRem(10)};
  width: ${pxToRem(24)};
  fill: black;
  cursor: pointer;
`
